import { useQuery } from '@tanstack/react-query';

import {
  getDistributionConnectionsById,
  type GetDistributionConnectionsByIdResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import queryKeys from '@/queries/queryKeys';
import type { QueryOptions } from '@/types/react-query';

export default function useDistributionConnections(
  distributionId: string,
  options?: QueryOptions<GetDistributionConnectionsByIdResponse['connections']>,
) {
  return useQuery({
    queryKey: queryKeys.distributions.connections(distributionId),
    queryFn: async () => {
      const result = await getDistributionConnectionsById(
        { path: { distribution_id: distributionId } },
        wgApi,
      );

      return result.connections;
    },
    ...options,
  });
}
